export * from './favorite.component';
